import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { ModalComponent } from "@app/shared/components";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-authentication-info-modal',
    templateUrl: './authentication-info-modal.component.html',
    styleUrls: ['./authentication-info-modal.component.scss']
})
export class AuthenticationInfoModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() missingRoleMessage: string;
    @Input() missingBoschIdMessage: string;
    @Input() displayScanMode: boolean;
    @Output() scanEvent = new EventEmitter<any>();

    focused = true;
    scanInput = '';
    isScanninInProgress = false;
     _logger = Log.create(AuthenticationInfoModalComponent.name);


    constructor() {
    }

    ngOnInit() {
    }

    open() {
        this.modal.open();
    }

    isOpen() {
        return this.modal.isOpen();
    }

    close() {
        this.modal.close();
        this.isScanninInProgress = false;
    }

    stopScanningProcess() {
        this.isScanninInProgress = false;
    }

    onCancel() {
        this.close();
    }

    onScan(boschId: string) {
        this._logger.info('onScan:: BoschId: ' + boschId);

        this.isScanninInProgress = true;
        this.scanInput = boschId;
        this.scanEvent.emit(boschId);

    }

    @HostListener('window:focus', ['$event'])
    onFocus() {
        this.focused = true;
    }

    @HostListener('window:blur', ['$event'])
    onBlur() {
        this.focused = false;
    }

}
